export const dcrSuccessModalContentStyles = {
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		flexDirection: 'column',
		gap: 1.5
	},

	icon: {
		width: '120px',
		height: '120px'
	},

	button: {
		mb: 1
	}
};
